var products_card = document.querySelectorAll(".product-wrapper");
products_card.forEach(product => {
  var cells = product.querySelectorAll(".product-inner-wrapper");
  if (window.innerWidth >= 768) {
    var hasMultipleCells = cells.length > 3;
    var groupCells = 3;
  } else {
    var hasMultipleCells = cells.length > 1;
    var groupCells = 1;
  }
  if (hasMultipleCells) {
    var flkty = new Flickity(product, {
      cellAlign: "left",
      contain: true,
      groupCells: groupCells,
      wrapAround: true,
      autoPlay: false,
      pauseAutoPlayOnHover: true,
      imagesLoaded: true,
    });
  }
});
